define('SageDotCom/DataLayer/Events/product-card-detail',[
    "jquery",
    "SageDotCom/DataLayer/Events/eventBase",
    "SageDotCom/DataLayer/tealium"
], function ($, eventBase, tealium) {

    //el, eventName, eventAction
    function ProductCardDetailEvent() {
        eventBase.call(this);
    }

    ProductCardDetailEvent.prototype = Object.create(eventBase.prototype);

    ProductCardDetailEvent.prototype.getProductInformation = (sku, promoCode = "", locale) => {
        let url = $("head meta[name='ecommerce']").attr("content");
        if (!url || typeof url !== "string" || url.trim() === "") {
            console.error("fetch product info error: url is empty");
            return;
        }
        url = url.trim();

        if (!url.endsWith("/")) {
            url += "/";
        }

        if (sku && locale) {
            const sanitizedLocale = (locale === "{locale}") ? document.location.pathname.split("/")[1] : locale;
            return $.ajax({
                type: "GET",
                url: `${url}ecommerce/v1/product/${encodeURIComponent(sku.trim())}/card`,
                data: {
                    basePromoCode: promoCode
                },
                headers: {
                    locale: sanitizedLocale.toLowerCase(),
                    "X-Correlation-Id": crypto.randomUUID()
                },
                dataType: "json"
            });
        }
    }

    ProductCardDetailEvent.prototype.productDetailEvent = function (sku, originalSku, promoCode, locale, trigger, isCrossSell, cardScope) {
        if (sku !== "" && locale !== "") {
            const sanitizedLocale = (locale === "{locale}") ? document.location.pathname.split("/")[1] : locale;
            const productInfoIdentifier = `ProductInfo${sku}${sanitizedLocale}`;
            const storedProductInfo = document.getElementById(productInfoIdentifier);
            let productCardData = null;
            try {
                if (storedProductInfo) {
                    const storedProductCardDataResult = storedProductInfo.text;
                    if (storedProductCardDataResult) {
                        productCardData = JSON.parse(storedProductCardDataResult);
                    }
                }
                if (!productCardData) {
                    $.when(this.getProductInformation(sku, promoCode, sanitizedLocale)).done((fetchedData) => {
                        if (fetchedData) {
                            this.storeScript(productInfoIdentifier, fetchedData);
                            this.populateDetailEvent(fetchedData, originalSku, trigger, isCrossSell);

                            if (cardScope) {
                                $(cardScope).attr("data-product-family", fetchedData.productFamily);
                            }
                        }
                    }).fail((fetchError) => {
                        console.error("fetch product info error: ", fetchError);
                    });
                } else {
                    if (cardScope) {
                        $(cardScope).attr("data-product-family", productCardData.productFamily);
                    }
                    this.populateDetailEvent(productCardData, originalSku, trigger, isCrossSell);
                }
            } catch (err) {
                console.error(err);
            }
        }
    };

    ProductCardDetailEvent.prototype.triggerAddToCartTealiumEvent = function (originalUrl, buttonScope, entryMethod, whenCompleteCallBack = null) {
        const productCardUrl = this.parseURL(originalUrl);
        const executeCallback = () => {
            if (whenCompleteCallBack) {
                whenCompleteCallBack();
            }
            return; //explicit Exit
        };
        if (!productCardUrl || productCardUrl.length === 0) {
            executeCallback();
            return;
        }
        const slashIndex = productCardUrl.indexOf("/", 1);
        if (slashIndex === -1) {
            executeCallback();
            return;
        }
        const locale = productCardUrl.substring(1, slashIndex);
        const sku = this.parseUrlData(productCardUrl, "sku");
        if (!sku || !locale) {
            executeCallback();
            return;
        }
        const promoCode = this.parseUrlData(productCardUrl, "promoCode");
        const productInfoIdentifier = `ProductInfo${sku}${locale}`;
        const storedProductInfo = document.getElementById(productInfoIdentifier);
        try {
            let productResponse = null;
            if (storedProductInfo) {
                const storedProductCardDataResult = storedProductInfo.text;
                if (storedProductCardDataResult) {
                    productResponse = JSON.parse(storedProductCardDataResult);
                }
            }

            if (!productResponse) {
                $.when(this.getProductInformation(sku, promoCode, locale))
                    .done((fetchedData) => {
                        if (fetchedData) {
                            this.storeScript(productInfoIdentifier, fetchedData);
                            this.populateAddToCartEvent(fetchedData, originalUrl, buttonScope, entryMethod);
                        }
                        executeCallback();
                    })
                    .fail((fetchError) => {
                        console.error("Fetch product info error:", fetchError);
                        executeCallback();
                    });
            } else {
                this.populateAddToCartEvent(productResponse, originalUrl, buttonScope, entryMethod);
                executeCallback();
            }
        } catch (err) {
            console.error(err);
            executeCallback();
        }
    };


    ProductCardDetailEvent.prototype.buildEventData = function (data, trigger, isCrossSell, originalSku) {
        const product = data;
        //Skip event if product is null/undefined or if it is cross sell & original sku matches the product sku
        if (!product || (isCrossSell && product.sku === originalSku)) {
            return null;
        }
        const productTotals = product.total;
        const unitPrice = (productTotals && Number(productTotals.listPrice)) ? Number(productTotals.listPrice).toFixed(2) : "0.00";
        const eventdata = {
            "currency": product.currencyCode,
            "coupon": [""],
            "discount": ["0.00"],
            "item_id": [product.sku],
            "item_name": [product.shortName],
            "item_list_name": [product.productFamily],
            "item_variant": [product.productVariant],
            "price": [unitPrice],
            "quantity": [1],
            "triggered_by": trigger,
            "offer_period": ["0"],
            "offer_name": [""]
        };
        //Update promotion info
        const promotion = data.discount;
        if (promotion) {
            eventdata.discount = [Number(promotion.value) ? Number(promotion.value).toFixed(2) : "0.00"];
            eventdata.offer_name = [promotion.name || promotion.description || ""];
            eventdata.coupon = [promotion.discountCode || ""];
            if (promotion.length && Number(promotion.length)) {
                eventdata.offer_period = [promotion.length.toString()];
            }
        }
        return eventdata;
    };

    ProductCardDetailEvent.prototype.populateDetailEvent = function (data, originalSku, trigger, isCrossSell) {
        try {
            const eventdata = this.buildEventData(data, trigger, isCrossSell, originalSku);
            if (!eventdata) {
                return;
            }

            eventdata.event = "ee_view_item";

            tealium.event(eventdata);
        } catch (err) {
            console.error(err);
        }
    };

    ProductCardDetailEvent.prototype.populateAddToCartEvent = function (data, productCardUrl, buttonScope, entryMethod) {
        try {
            const eventdata = this.buildEventData(data, "button", false, null);
            if (!eventdata) {
                return;
            }

            eventdata.event = "ee_add_to_cart";
            eventdata.value = eventdata.price[0];
            eventdata.destination_url = productCardUrl || "";
            eventdata.element_text = $(buttonScope).text() || "";
            eventdata.element_id = $(buttonScope).attr("id") || "";
            eventdata.element_class = $(buttonScope).attr("class") || "";
            eventdata.platform = "sitecore";
            eventdata.cart_entry_method = entryMethod;
            tealium.event(eventdata);
        } catch (err) {
            console.error(err);
        }
    };

    //old commerce
    ProductCardDetailEvent.prototype.addToCartTealiumOld = function (product, url, buttonScope) {

        try {
            product.price = product.price.toString().replace(/\D/g, ""); //filter out non numeric characters
            if (product.price != null && product.price !== "")
                product.price = Number(product.price).toFixed(2);

            var eventData = {
                "product_level": isPrimaryProduct(product.sku) ? "primary" : "minor",
                "event": "ua_add_to_cart",
                "currency": "",
                "value": "",
                "element_text": $(buttonScope).text(),
                "element_id": $(buttonScope).attr("id"),
                "element_class": $(buttonScope).attr("class"),
                "destination_url": url,
                "triggered_by": "button",
                "item_id": [product.sku],
                "item_name": [product.title],
                "item_variant": [],
                "item_list_name": [product.subtitle],
                "quantity": [],
                "price": [product.price.toString()],
                "billing_cycle": [],
                "billing_period": [],
                "coupon": [],
                "discount": [],
                "offer_name": [],
                "offer_period": []
            };

            tealium.event(eventData);
        } catch (e) {
            console.error(e);
        }
    }

    //UTILS
    const pagePrimaryMetaProductUrls = $("*[data-pd-url-variances]");
    function isPrimaryProduct(sku) {
        if (sku !== "" && pagePrimaryMetaProductUrls) {
            for (let i = 0; i < pagePrimaryMetaProductUrls.length; i++) {
                if (pagePrimaryMetaProductUrls[i].getAttribute("data-pd-url-variances").indexOf(sku) >= 0) {
                    return true;
                }
            }
        }
        return false;
    }

    ProductCardDetailEvent.prototype.parseURL = function (url) {
        var productCardUrl = url;
        if (productCardUrl) {
            var comIndex = url.indexOf(".com");
            if (comIndex !== -1) {
                productCardUrl = url.substring(comIndex + 4);
            }
        }
        return productCardUrl;
    }

    ProductCardDetailEvent.prototype.parseUrlData = function (urlString, urlParameter) {
        if (urlString) {
            var slashIndex = urlString.toLowerCase().indexOf(urlParameter.toLowerCase());
            if (slashIndex === -1)
                return "";
            var returnValue = urlString.substring(slashIndex);
            returnValue = returnValue.substring(urlParameter.length + 1);

            if (returnValue.indexOf("&") > -1) {
                slashIndex = returnValue.indexOf("&");
                returnValue = returnValue.substring(0, slashIndex);
            }
            return returnValue;
        }
        return "";
    }

    ProductCardDetailEvent.prototype.storeScript = function (scriptId, scriptContent) {
        const head = document.getElementsByTagName("head")[0];
        const script = document.createElement("script");
        script.type = "text/json";
        script.id = scriptId;
        script.text = JSON.stringify(scriptContent);
        head.appendChild(script);

        window.medalliaObj = window.medalliaObj || {};

        if (scriptContent != null && scriptContent.sku && typeof scriptContent.shortName === "string") {
            window.medalliaObj.product_name = scriptContent.shortName;
            window.medalliaObj.product_sku = scriptContent.sku;
        }

        return true;
    }

    return ProductCardDetailEvent;
});
